import React, { useRef, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';
import { PaymentCardNew } from './payment-card-new';
import { PaymentDetails } from './payment-details';
import { PaymentCardListItem } from './payment-card-list-item';

function SelectPaymentCardModalBody({
  cards,
  payment,
  spot,
  menuInfo,
  menuLayout,
  feature,
  disabled,
  stripePromise,
  onSelect,
  onDelete,
  onCVCChange,
  onOtherCardClick,
  onError,
  onSuccess,
}) {
  const classes = useStyles();
  const [selectedCard, setSelectedCard] = useState();
  const setSelectedErrorRef = useRef(null);
  const [isUnderError, setIsUnderError] = useState(false);

  // useEffect(() => {
  //   if (selectedCard != null) {
  //     onSelect?.call(this, selectedCard, setSelectedErrorRef.current);
  //   }
  // }, [selectedCard]);

  function isSelected(card) {
    return selectedCard?.id === card.id;
  }

  const handleOnSelect = (props) => {
    // if (isSelected(card)) {
    //   setSelectedCard(null);
    // } else {
    setIsUnderError(false);
    setSelectedErrorRef.current = props.setError;
    setSelectedCard(props.card);

    onSelect?.call(this, props);
    // console.log('handleOnSelect', card);
    // }
  };

  const handleOnError = (error, handleGeneric) => {
    setIsUnderError(true);
    onError?.call(this, error, handleGeneric);
  };

  return (
    <div className={classes.container}>
      {cards?.map((card) => (
        <PaymentCardListItem
          key={card.id}
          card={card}
          stripePromise={stripePromise}
          menuInfo={menuInfo}
          menuLayout={menuLayout}
          disabled={disabled}
          clientSecret={payment?.card.client_secret}
          intentId={payment?.card.intent_id}
          payment={payment}
          isSelected={isSelected(card)}
          onSelect={handleOnSelect}
          onDelete={onDelete}
          onCVCChange={onCVCChange}
          onSuccess={onSuccess}
          onError={handleOnError}
          isUnderError={isUnderError}
        />
      ))}
      <PaymentCardNew onClick={onOtherCardClick} disabled={disabled} />
      <PaymentDetails
        style={classes.total}
        payment={payment}
        spot={spot}
        menuInfo={menuInfo}
        feature={feature}
        // stripe={stripe}
      />
      {/* <div className={classes.footer}>
        <Button
          variant="link"
          className={classes.link}
          onClick={onOtherCardClick}
          aria-hidden
        >
          Usar outro cartão
        </Button>
      </div> */}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid white',
  },
  link: {
    cursor: 'pointer',
    fontSize: layoutDefaults.fontSize,
    color: layoutDefaults.linkColor,
    padding: 0,
    margin: 0,
  },
  footer: {
    marginTop: layoutDefaults.bigVerticalMargin,
    marginDown: layoutDefaults.biggerVerticalMargin,
  },
  total: {
    marginTop: layoutDefaults.bigVerticalMargin,
  },
});

export { SelectPaymentCardModalBody };
